
import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import reportingMetaData from 'ReportingMetaDataModel'
import listService from 'ListService';
import nameTemplate from 'report/properties/main/data-source.ejs';


class MainDataSourceView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #dataSource' :'updateDataSource'
        };

        this.updateDefaultDataSource()

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateDefaultDataSource(){
      const currentDataSourceId=this.model.get('dataSourceId');
      if(!currentDataSourceId){
        let firstDataSource=listService.getDataSources().first();
        let cleanDataSourceId= firstDataSource ? listService.cleanId(firstDataSource.id) : undefined;
        // always assign original datasource id
        this.model.set('dataSourceId', listService.getCleanedId(cleanDataSourceId));
        if (this.model.get('factoryKey') !=='control_clear_filter_button') {
            listService.setReportingMetaData(cleanDataSourceId,this.model,true);
        }
      }
    }

    updateDataSource(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        // remove previous MetaData
        listService.deleteReportMetaData( this.model.get('id'));

        if (propVal !== 'none' && this.model.get('factoryKey') !=='control_clear_filter_button') {
            const pg = listService.getPage( listService.currentPageId );

            // Set new MetaData
            const metadata = new reportingMetaData({
                id: this.model.get('id'),
                name: pg.model.get('name') + '|' + this.model.get('name'),
                dataSource: propVal,
                isAggregate: 'true',
                ignoreNull: 'false'
            });

            metadata.Columns = [];
            let aggregation;
            let sortType;

            if (this.model.get('factoryKey') === 'control_filter_input') {
                sortType = 'none';
            }
            if (this.model.get('factoryKey') === 'control_value') {
                aggregation = 'count';
                sortType = 'none';
            }
            if (this.model.get('factoryKey') === 'control_filter_selector') {
                aggregation = 'group';
                sortType = 'none';
            }

            const column0 = {
                id: "0",
                aggregation: aggregation,
                sortType: sortType,
                sortOrder: '0',
                visible: true,
                Expression: {}
            };
            column0.Expression.Argument = {type: 'reporting_datasourceField', value: '', dataType: ''};
            metadata.Columns.push(column0);

            listService.addReportingMetaData(metadata);
        }

        let columnFields = this.model.get('Columns');
        if (columnFields && this.model.get('factoryKey') !=='control_clear_filter_button') {
            if (columnFields.Column) {
                _.forEach(columnFields.Column, column => column.Properties.fieldId = "");
            }            
        }
        //always assign original id for datasources
        this.model.set( propName, listService.getCleanedId(propVal) );
    }

    populateDataSources() {
        const elDataSources = $('#dataSource');
        if (elDataSources) {
            //elDataSources.empty();
            const ds = listService.getDataSources();
            ds.map((v, k) => {
                elDataSources[0].options[elDataSources[0].options.length] = new Option(v.name, v.id, (v.uses || 0));
            });
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.populateDataSources();
        const currentDataSourceId=this.model.get('dataSourceId');

        if (currentDataSourceId && currentDataSourceId !== 'none') {
            let value=listService.cleanId(this.model.get('dataSourceId'));
            $('#dataSource').find('option[value=' + value + ']').prop('selected', true);
        }
        else{
            $('#dataSource').find('option[value=' + currentDataSourceId + ']').prop('selected', true);
        }

        this.delegateEvents();
        return this;
    }

}

export default MainDataSourceView;
